define('lib/Podio.UI.ActionDropdown',['require','jquery','lib/Podio.Event.UI','lib/Podio.UI.Tooltips'],function(require) {

  var $ = require('jquery');
  var eventUI = require('lib/Podio.Event.UI');
  var tooltips = require('lib/Podio.UI.Tooltips');

  function hideAllDropdowns() {
    $('.action-dropdown-wrapper:visible').each(function() {
      hideDropdown($(this), $(this).siblings('.action-dropdown, .action-dropdown-trigger'));
    });
  }

  function hideDropdown(elmDropdown, elmOpenLink) {

    if (!elmDropdown.is(':visible')) {
      return;
    }

    elmDropdown.unbind('outsideclick');
    elmDropdown.hide();

    elmOpenLink.removeClass('open');
    elmOpenLink.trigger('action-dropdown.closed');
    elmOpenLink.find('.icon').addClass('icon-arrow-down-grey').removeClass('icon-arrow-up-grey');
  }

  function onOutsideClick(elmDropdown, elmOpenLink, e) {
    if (($(e.target).is('.action-dropdown, .action-dropdown-trigger')) || ($(e.target).parents('.action-dropdown, .action-dropdown-trigger').length)) {
      return;
    }

    hideDropdown(elmDropdown, elmOpenLink);
  }

  function onActionDropDownLinkClick(elmTarget, e) {

    if (elmTarget.hasClass('open')) {
      hideAllDropdowns();
      return;
    }

    tooltips.hideAll();

    elmTarget.addClass('open');
    elmTarget.find('.icon').removeClass('icon-arrow-down-grey').addClass('icon-arrow-up-grey');

    var dropContent = elmTarget.siblings('.action-dropdown-options').html();
    var elmDropdownWrapper = elmTarget.siblings('.action-dropdown-wrapper');

    if (!elmDropdownWrapper.length) {
      elmDropdownWrapper = $('<div>', { 'class': 'action-dropdown-wrapper', html: dropContent});
      $('<div>', { 'class':'overlap', width: elmTarget.innerWidth() + 1 }).appendTo(elmDropdownWrapper);
      elmDropdownWrapper.css('min-width', elmTarget.data('dropdown-min-width') || elmTarget.outerWidth());
      if (elmTarget.hasClass('align-left')) {
        elmDropdownWrapper.addClass('align-left');
      }

      elmTarget.after(elmDropdownWrapper);
    }

    // Hide other dropdowns
    $('.action-dropdown-wrapper').not(elmDropdownWrapper).each(function() {
      hideDropdown($(this), $(this).siblings('.action-dropdown, .action-dropdown-trigger'));
    });

    elmTarget.trigger('action-dropdown.opened');

    if (elmTarget.hasClass('align-left')) {
      elmDropdownWrapper.css({ 'top' : elmTarget.position().top + elmTarget.innerHeight() , 'left' : elmTarget.position().left + elmTarget.outerWidth() - elmDropdownWrapper.outerWidth() });
    } else {
      elmDropdownWrapper.css({ 'top' : elmTarget.position().top + elmTarget.innerHeight() , 'left' : elmTarget.position().left });
    }

    elmDropdownWrapper.show();
    elmDropdownWrapper.bind("outsideclick", onOutsideClick.curry(elmDropdownWrapper, elmTarget));
  }

  function onDropdownItemClick(elmTarget, e) {

    var elmWrapper = elmTarget.parents('.action-dropdown-wrapper');
    var elmOpenLink = elmWrapper.siblings('.action-dropdown, .action-dropdown-trigger');

    elmTarget.parents('li').addClass('current').siblings('.current').removeClass('current');
    if (elmWrapper.length && elmOpenLink.length) {
      hideDropdown(elmWrapper, elmOpenLink);
    }
  }

  eventUI.bind('click', '.action-dropdown, .action-dropdown-trigger', onActionDropDownLinkClick);
  eventUI.bind('click', '.action-dropdown-wrapper ul li a', onDropdownItemClick, true);

  return {
    hideAll: hideAllDropdowns
  };

});



